import React from "react";
import Group from "../UI/Group/Group";
import Button, { BUTTON_VARIANTS } from "../UI/Button/Button";
import createLink from "../../../libs/createLink";
import "./UserRestrictions.scss";

const UserRestrictions = () => {
    return (
        <div className="user-restrictions">
            <p>
                Cette action n’est pas disponible actuellement en raison d’une restriction appliquée à votre compte.
                Vous pouvez consulter les détails pour comprendre la situation.
            </p>

            <Group right>
                <Button
                    variant={BUTTON_VARIANTS.REVERSE}
                    isLink
                    to={createLink("userMeSettingsSignalements")}
                >
                    En savoir plus
                </Button>
            </Group>
        </div>
    );
};

export default UserRestrictions;
